import { useDebounce } from '../../../../../_helpers/hooks/useDebounce';
import { useHydrated } from '../../../../../_helpers/hooks/useHydrated';
import { useLocalCSSRule } from '../../../../../_helpers/hooks/useLocalCSSRule';
import { type KeyboardEvent, type FC, type CSSProperties } from 'react';
import { Answer } from '../Poll.model';

type PollAnswerProps = {
	answered: boolean;
	percentage: number;
	onKeyDown: (e: KeyboardEvent) => void;
} & Answer;

export const PollAnswer: FC<PollAnswerProps> = ({
	answer,
	answered,
	percentage,
	onKeyDown,
}) => {
	const animate = useDebounce(true, 0, false);
	const id = useLocalCSSRule(
		{ ['--percentage']: percentage + '%' } as CSSProperties,
		[percentage],
		'answer-'
	);
	const hydrated = useHydrated();
	return (
		<div
			id={hydrated ? id : ''}
			className={['answer result', animate && 'animate'].join(' ')}
			role="radio"
			aria-checked={answered}
			aria-disabled
			tabIndex={0}
			onKeyDown={onKeyDown}
		>
			<div className="answer-text">
				<span>{answer}</span>
				{answered && (
					<i
						className="fa fa-check-circle"
						data-testid="poll-checked-answer-icon"
					/>
				)}
			</div>
			<span className="answer-percentage">{percentage}%</span>
		</div>
	);
};
